export enum ELabelPriceVariant {
    ITEM = "item",
    TOTAL = "total",
}
